import { articleSensitivityLayout } from 'utils/layoutUtils';
import {topMPUProps, singleBottomMPUProps, bannerAd, bottomMPUProps} from 'modules/Common/components/GptProperties'

const leaderboardAd = {
  view: 'racing'
};

const topMPU = {
  component: 'GooglePublisherTag',
  props: topMPUProps,
  desktopColumn: 'right',
  desktopOrder: 1,
  handheldOrder: false
};

const bottomMPU = {
  component: 'GooglePublisherTag',
  props: bottomMPUProps,
  desktopColumn: 'right',
  desktopOrder: 3,
  handheldOrder: false
};

const mostRead =   {
  component: "MostReadRacing",
  desktopColumn: "right",
  desktopOrder: 1,
  handheldOrder: 3
};

const nextRaceOff = {
  component: "HorseRacingNextRaceOff",
  props: {
    displayAll: true
  },
  desktopColumn: "right",
  desktopOrder: 2,
  handheldOrder: false
};

const tips = {
  component: "RacingTips",
  desktopColumn: "right",
  desktopOrder: 3,
  handheldOrder: false
};

const advertMPU = {
  component: "AdvertWrapper",
  props: {
    ocSlot: ["racing", "mpu"],
    additionalProperties: {
      view: "racing"
    }
  },
  desktopColumn: "right",
  desktopOrder: 4,
  handheldOrder: false
};

const defaultSideBarComponentsNoTips = [topMPU, nextRaceOff, bottomMPU, advertMPU];
const defaultSideBarComponents =       [topMPU, nextRaceOff, tips, bottomMPU, advertMPU];
const defaultSideBarComponentsNoAds =  [nextRaceOff, tips];

const getMostFollowed = (desktopOrder, handheldOrder) => ({
  component: "HorseRacingMostFollowed",
  desktopColumn: "right",
  desktopOrder,
  handheldOrder
});

const withAdverts = (...components) => ({
  bannerAd,
  leaderboardAd,
  components: [...components, ...defaultSideBarComponents]
});

const withAdvertsAndMostRead = (...components) => ({
  bannerAd,
  leaderboardAd,
  components: [...components, mostRead, ...defaultSideBarComponents]
});

const withAdvertsNoTips = (...components) => ({
  bannerAd,
  leaderboardAd,
  components: [...components, ...defaultSideBarComponentsNoTips]
});

const withAdvertsAndMostReadNoTips = (...components) => ({
  bannerAd,
  leaderboardAd,
  components: [...components, mostRead, ...defaultSideBarComponentsNoTips]
});

const withAdvertsArticle = (...components) => ({
  leaderboardAd,
  components: [...components, mostRead, ...defaultSideBarComponents]
});

const withoutAdvertsArticle = (...components) => ({
  components: [...components, mostRead, ...defaultSideBarComponentsNoAds]
});

const racingHomePageLayout = withAdvertsAndMostRead(
  {
    component: "MoreNews",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  }
  ,
  {
    component: 'GptAdvert',
    props: {
      ocDetails: {
        ocSlot: ['racing', 'leaderboard']
      },
      performDetails: singleBottomMPUProps
    },
    desktopColumn: 'left',
    desktopOrder: 2,
    handheldOrder: 2
  }
);

const racingFastcardsPageLayout = withAdverts({
    component: "HorseRacingFastCards",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  }
);

const racingNonRunnersPageLayout = withAdverts({
  component: "HorseRacingNonRunnersContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

const racingGoingPageLayout = withAdverts({
  component: "HorseRacingGoingContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

const racingRacecardsPageLayout = withAdverts({
    component: "HorseRacingRacecardsForDateContainer",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  },
  getMostFollowed(5, 2)
);

const racingFastResultsPageLayout = withAdverts({
    component: "HorseRacingFastResults",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  },
  getMostFollowed(5, 2)
);

const racingMeetingLandingPageLayout = withAdverts({
  component: "HorseRacingMeetingLandingContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

const racingRacePageLayout = withAdverts({
    component: "HorseRacingRacePageContainer",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  },
  getMostFollowed(5, 2)
);

const racingResultPageLayout = withAdverts({
    component: "HorseRacingRacePageContainer",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  }
);

const racingResultsPageLayout = withAdverts({
    component: "HorseRacingResultsForDateContainer",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  },
  getMostFollowed(5, 2)
);

const racingEarlyEntiresPageLayout = withAdverts({
  component: "HorseRacingEarlyEntriesContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

const racingHorseProfilePageLayout = withAdverts({
  component: "HorseProfilePageContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

const racingTrainerProfilePageLayout = withAdverts({
  component: "TrainerProfilePageContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

const racingJockeyProfilePageLayout = withAdverts({
  component: "JockeyProfilePageContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

const racingTipsCentrePageLayout = withAdvertsAndMostReadNoTips({
    component: "MoreNews",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  },
  getMostFollowed(5, 2)
  );

const racingRichardFaheyPageLayout = withAdvertsAndMostRead({
  component: 'SectionPlainTitle',
  props: {
    level: 1,
    className: 'page-main-section-title',
    children: 'Richard Fahey'
  },
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
},{
  component: "MoreNews",
  desktopColumn: "left",
  desktopOrder: 2,
  handheldOrder: 2
});

const racingMyStable = withAdvertsNoTips({
    component: "MyStablePageContainer",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  },
  getMostFollowed(2, 2)
);

const napsTableLayout = withAdverts({
    component: 'NapsTable',
    desktopColumn: 'left',
    desktopOrder: 1,
    handheldOrder: 1
  },
  getMostFollowed(5, 2)
);

const abcGuideLayout = withAdverts({
    component: 'HorseRacingAbcGuide',
    desktopColumn: 'left',
    desktopOrder: 1,
    handheldOrder: 1
  },
  getMostFollowed(5, 2)
);

const insightsLayout = withAdverts({
    component: 'InsightDescriptionsContainer',
    desktopColumn: 'left',
    desktopOrder: 1,
    handheldOrder: 1
  },
  getMostFollowed(5, 2)
);

const article = {
  component: 'Article',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
};
const racingArticleLayout = withAdvertsArticle(article);
const racingArticleSensitiveLayout = withoutAdvertsArticle(article);

export default {
  '/racing': racingHomePageLayout,
  '/racing/fast-cards/:meetingId/:date/:courseSlug': racingFastcardsPageLayout,
  '/racing/going': racingGoingPageLayout,
  '/racing/non-runners': racingNonRunnersPageLayout,
  '/racing/racecards': racingRacecardsPageLayout,
  '/racing/racecards/:date': racingRacecardsPageLayout,
  '/racing/fast-results': racingFastResultsPageLayout,
  '/racing/meeting/:meetingDate/:meetingName/:meetingId': racingMeetingLandingPageLayout,
  '/racing/fast-results/all': racingFastResultsPageLayout,
  '/racing/racecards/:date/:courseSlug/racecard/:raceId/:raceSlug': racingRacePageLayout,
  '/racing/racecards/:date/:courseSlug/live-show/:raceId/:raceSlug': racingRacePageLayout,
  '/racing/results': racingResultsPageLayout,
  '/racing/results/:date': racingResultsPageLayout,
  '/racing/results/:date/:courseSlug/:raceId/:raceSlug': racingResultPageLayout,
  '/racing/early-entries': racingEarlyEntiresPageLayout,
  '/racing/profiles/horse/:horseId': racingHorseProfilePageLayout,
  '/racing/profiles/horse/:horseId/wins': racingHorseProfilePageLayout,
  '/racing/profiles/horse/:horseId/winsandpl': racingHorseProfilePageLayout,
  '/racing/profiles/horse/:horseId/after60': racingHorseProfilePageLayout,
  '/racing/profiles/horse/:horseId/future-entries': racingHorseProfilePageLayout,
  '/racing/profiles/trainer/:trainerId': racingTrainerProfilePageLayout,
  '/racing/profiles/trainer/:trainerId/future-entries': racingTrainerProfilePageLayout,
  '/racing/profiles/jockey/:jockeyId': racingJockeyProfilePageLayout,
  '/racing/profiles/jockey/:jockeyId/future-entries': racingJockeyProfilePageLayout,
  '/racing/tips-centre': racingTipsCentrePageLayout,
  '/racing/columnists/richard-fahey': racingRichardFaheyPageLayout,
  '/racing/my-stable': racingMyStable,
  '/racing/my-stable/results': racingMyStable,
  '/racing/my-stable/selections': racingMyStable,
  '/racing/my-stable/search': racingMyStable,
  '/racing/my-stable/unsubscribe': racingMyStable,
  '/racing/news/:title/:articleId': layout => articleSensitivityLayout(layout, racingArticleLayout, racingArticleSensitiveLayout),
  '/racing/naps-table': napsTableLayout,
  '/racing/abc-guide': abcGuideLayout,
  '/racing/abc-guide/:days': abcGuideLayout,
  '/racing/abc-guide/:days/:type': abcGuideLayout,
  '/racing/abc-guide/:days/:type/:letterRange': abcGuideLayout,
  '/racing/insights': insightsLayout
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/layouts.js